import { useNavigate } from 'react-router-dom';
import { FC, useEffect } from 'react';
import { PageProps } from 'shared/defines';
import Lottie from 'lottie-react';
import animationTickGreen from '../shared/assets/lottie/animationTickGreen.json';
import Button from '../shared/components/buttons';
import { TextDecoder } from '../shared/text-effects/TextDecoder';

const CompletePage: FC<PageProps> = ({ title }) => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = title;
  }, [title]);

  const handleSignAnotherWaiver = () => {
    navigate('/email');
  };

  return (
    <div className="w-full flex-1 flex flex-col sm:justify-center gap-8">
      <div className="flex flex-col px-4 sm:px-0">
        <div className="whitespace-pre flex h-9 sm:h-14">
          <TextDecoder
            className="font-aeonik font-medium text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] gap-5"
            delay={0}
            duration={500}
            animationType={'in'}
            text="You're all set!"
          />
        </div>
        <div className="w-50 h-50 sm:w-55 sm:h-55 -ml-5">
          <Lottie loop={false} autoplay={true} animationData={animationTickGreen} />
        </div>
      </div>
      <div className="flex flex-col px-4 -mt-4 sm:px-0">
        <div className="text-[1.2rem]/[1.2rem] font-medium border-b-1 border-white pb-3">
          Do you have another child attending the party?
        </div>
        <Button
          variant="filled"
          size="sm"
          className="mt-5 text-[1.2rem] w-full sm:w-57.5"
          onClick={handleSignAnotherWaiver}
        >
          Sign another waiver
        </Button>
      </div>
      <div className="flex flex-col">
        <h2 className="sm:text-[1.875rem]/[1.875rem] text-[2.125rem]/[2.125rem] text-white font-aeonik font-medium px-4 sm:px-0">
          Important tips before your child’s visit
        </h2>
      </div>
      <div className="flex flex-col">
        <div className="w-full flex gap-3.5">
          <div className="w-1.5 h-1.5 rounded-1.25 bg-aqua-reach"></div>
          <div className="flex-1 text-[1.875rem]/[1.3rem] -mt-1 text-aqua-reach font-dotted">01</div>
          <div className="w-1.5 h-1.5 rounded-1.25 bg-aqua-reach"></div>
        </div>
        <div className="text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] mx-5 font-medium text-aqua-reach">
          Wear athletic shoes
        </div>
        <div className="text-[1.2rem]/[1.2rem] mt-2 mx-5 font-medium">
          Sneakers or trainers are required to play the games
        </div>
      </div>
      <div className="flex flex-col mt-2">
        <div className="w-full flex gap-3.5">
          <div className="w-1.5 h-1.5 rounded-1.25 bg-yellow-hit"></div>
          <div className="flex-1 text-[1.875rem]/[1.3rem] -mt-1 text-yellow-hit font-dotted">02</div>
          <div className="w-1.5 h-1.5 rounded-1.25 bg-yellow-hit"></div>
        </div>
        <div className="text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] mx-5 font-medium text-yellow-hit">
          Arrive <span className="hidden sm:inline">15 min </span>early
        </div>
        <div className="text-[1.2rem]/[1.2rem] mt-2 mx-5 font-medium">To complete check-in and maximize game time</div>
      </div>
      <div className="flex flex-col mt-2">
        <div className="w-full flex gap-3.5">
          <div className="w-1.5 h-1.5 rounded-1.25 bg-pink-leap"></div>
          <div className="flex-1 text-[1.875rem]/[1.3rem] -mt-1 text-pink-leap font-dotted">03</div>
          <div className="w-1.5 h-1.5 rounded-1.25 bg-pink-leap"></div>
        </div>
        <div className="text-[2.125rem]/[2.125rem] sm:text-[3.1rem]/[3.4rem] hidden sm:block mx-5 font-medium text-pink-leap">
          Photosensitivity warning
        </div>
        <div className="text-[2.125rem]/[2.125rem] block sm:hidden mx-5 font-medium text-pink-leap">Warning</div>
        <div className="text-[1.2rem]/[1.2rem] mt-2 mx-5 font-medium">Games contain flashing lights</div>
      </div>
    </div>
  );
};

export default CompletePage;
